import { create } from "zustand";

type FlashbarItem = {
  type: 'info' | 'success' | 'error' | 'warning'
  dismissible: boolean
  dismissLabel: string
  onDismiss: () => void
  id: string,
  header?: string
  content: JSX.Element | string
}

type FlashbarState = {
  items: Array<FlashbarItem>
}

type FlashbarStateActions = {
  addItem: (item: FlashbarItem) => void
  removeItem: (id: string) => void
  clearFlashbar: () => void
}

const FlashbarStateStore = create<FlashbarState & FlashbarStateActions>((set) => ({
  items: [],
  addItem: (item: FlashbarItem) => set((state) => ({items: [...state.items, item]})),
  clearFlashbar: () => set(() => ({items: []})),
  removeItem: (id: string) => set((state) => ({items: state.items.filter(item => item.id !== id)}))
}))

export const useFlashbarStateStore = () => FlashbarStateStore((state) => state)
